import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import "./style.css";
import DeskFooter from "../../components/Footer/desktopFooter/";
import MobileFooter from "../../components/Footer/mobileFooter/";
import { Hidden } from "@material-ui/core";
import { toast } from "react-toastify";
import Axios from "screens/EnghelabSchoolForm/axios";
const TalayeDaranRegister = () => {
  const CurrentUser = useSelector((state) => state?.main?.currentUser);
  //   console.log(CurrentUser);
  const grd2 = () => {
    if (CurrentUser?.temp?.seventh_year !== "") {
      const g = 1405 - CurrentUser?.temp?.seventh_year + 7;
      if (g <= 9) return "متوسطه اول";
      else if (g >= 10 && g <= 12) return "متوسطه دوم";
    } else return "بدون مقطع";
  };
  const [formData, setFormData] = useState({
    fullName: "",
    n_code: "",
    gender: "",
    phone: "",
    province: "",
    county: "",
    grade: grd2(),
    // grade2: grd2(),
    // sv: CurrentUser?.temp?.seventh_year,
    schoolName: "",

    wantToHold: "",
    field: "talayedaran",
  });
  // console.log(formData)
  const [disBtn, setDisBtn] = useState(false);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    setFormData({
      ...formData,
      fullName: CurrentUser?.name,
      n_code: CurrentUser?.temp?.username,
      phone: CurrentUser?.temp?.phone,
      gender: CurrentUser?.gender,
      province: CurrentUser?.temp?.prv,
      county: CurrentUser?.temp?.county,
      // grade: GradeL(CurrentUser?.temp?.age),
      grade: grd2(),
    });
  }, [CurrentUser]);
  // console.log(formData)
  // روش‌های تحویل
  const deliveryMethods = [
    "تحویل درب منزل",
    "تحویل به مدرسه محل تحصیل",
    "تحویل به اتحادیه شهرستان",
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    // if (name === "postalCode" || name === "deliverPostalCode") {
    //   if (value !== "" && !/^\d+$/.test(value)) {
    //     return;
    //   }
    // }
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validateForm = () => {
    const newErrors = {};
    let hasEmpty = false;
    for (let key in formData) {
      // console.log(key)
      if (["province", "county"].includes(key)) continue;
      else if (formData[key]?.length === 0) {
        // console.log(key);
        hasEmpty = true;
      }
    }
    if (hasEmpty) {
      //   console.log(formData);
      toast.error("لطفا تمامی موارد را پر نمایید", { toastId: 1 });
      return;
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      //   console.log("Form Data:", formData);
      //   alert("فرم با موفقیت ثبت شد");
      const id = toast.loading("در حال ثبت نام...", { toastId: 1 });
      //   console.log(id);
      try {
        const { data } = await Axios.post("a/enghelab-school/register/", {
          ...formData,
          createAt: new Date(),
          userAgent: navigator?.userAgent,
        });
        // toast.success(data.message, { toastId: 1 });
        //do something else
        toast.update(id, {
          render: "ثبت نام شما با موفقیت انجام شد. خدا قوت!",
          type: "success",
          isLoading: false,
          autoClose: true,
        });
        setDisBtn(true);
      } catch (error) {
        // console.log(error);
        // toast.error("با خطا مواجه شد", { toastId: 1 });
        //do something else
        toast.update(id, {
          render: error?.response?.data?.message,
          type: "error",
          isLoading: false,
          autoClose: true,
        });
        setDisBtn(false);
      }
    }
  };
  const GradeL = (age) => {
    if (age >= 12 && age <= 14) return "متوسطه اول";
    else if (age >= 15 && age <= 18) {
      return "متوسطه دوم";
    } else return "بدون مقطع";
  };
  //  return (
  //    <h1 style={{
  //     textAlign:'center',
  //     display:'flex',
  //     justifyContent:'center',
  //     width:'100%'
  //    }}>ثبت نام به پایان رسید از شما متشکریم!</h1>
  // )
  return (
    <>
      <div className="form-container">
        <h1 style={{ textAlign: "center" }}>فرم ثبت نام دوره طلاییه دارن، سربازان لشکر انصار المهدی (عج)</h1>
        <div style={{ margin:10, textAlign: "justify", marginBottom: "20px" , border:'1px solid #ccc', padding:'10px', borderRadius:'5px'}}>
          <p style={{ lineHeight: "1.6", padding: 5 }}> 
            
سلام…<br/>
اگه الان داری این متن رو می‌ خونی… بدون که تو یه نوجوان معمولی نیستی.<br/>
آره…<br/>
تو یه نوجوان مؤثر و کنشگری…<br/>
از اونایی که منتظر نمی‌مونن تا آینده از راه برسه…<br/>
بلکه از امروز برای ساختنش آماده می‌شن<br/>
از اونایی که می‌دونن…<br/>
اثر گذاشتن روی دنیا…<br/>
از ساختن خود آدم شروع می‌شه<br/>
برای همین…<br/>
خودشون رو مجهز می‌کنن…<br/>
به ایمان…<br/>
به اراده…<br/>
و به مهارت<br/>
مهارت‌هایی که از یک نوجوان… یک انسان آماده می‌سازه…<br/>
آماده برای خدمت…<br/>
آماده برای مسئولیت…<br/>
و آماده برای اینکه در مسیر امام حیش قدم برداره…<br/>
و سربازی لشکر انصارالمهدی(عج) رو با افتخار انتخاب کنه<br/>
برای همین…<br/>
طلایه‌داران لشکر انصارالمهدی(عج) طراحی شده…<br/>
یک مسیر متفاوت…<br/>
که تو رو قدم‌به‌قدم…<br/>
برای نقش‌آفرینی در میدان بزرگ تمدن‌سازی آماده می‌کنه<br/>
این مسیر…
در چهار روز آغاز می‌شه…<br/>
روز اول؛ نجات‌غریق…<br/>
روزی که یاد می گیری نجات جان انسان ها، نه فقط با مهارت بلکه همراه با همکاری و همدلی میشه <br/>
روز دوم؛ دیده‌بان…<br/>
روزی که یاد می‌گیری قبل از هر حرکت، درست ببینی<br/>
روز سوم؛ رزم‌آور…<br/>
روزی برای ساختن اراده، انضباط و آمادگی هست <br/>
و روز چهارم؛ تکاور…<br/>
روزی که می‌فهمی هیچ قله‌ای برای یک نوجوان باایمان و پرتلاش دور از دسترس نیست و نیاز به آمادگی جسمانی داره... <br/>
اما…<br/>
ماجرا اینجا تموم نمی‌شه…<br/>
وقتی این چهار مرحله رو پشت سر گذاشتی…<br/>
وقتشه همه چیز رو…<br/>
در یک تجربه واقعی…<br/>
در یک اردویی هیجان‌انگیز…<br/>
 همان گونه که سربازان، میراث فرماندهانشان را بر دوش می کشند و راهشان را ادامه دهند... <br/>
زندگی کنی ... اینجا…<br/>
همه آموخته‌هات…<br/>
به یک مأموریت واقعی تبدیل می‌شن<br/>
اگر آماده‌ای…<br/>
نسخه قوی‌تر خودت رو کشف کنی…<br/>
اگر آماده‌ای…<br/>
در کنار رفقات…<br/>
برای آینده‌ای که امام زمان(عج) از ما انتظار داره، آماده بشی…<br/>
طلایه‌داران لشکر انصارالمهدی(عج)…<br/>
شروع راه توئه…<br/> 

اگر آماده یه ماجراجویی بزرگ هستی برای تبدیل شدن به یه نیروی موثر و کنشگر که می تونه آینده ایران رو بسازه؛ بسم الله. همین الان برای شرکت توی این اردو ثبت نام کن.
          </p>
        </div>
        <form onSubmit={handleSubmit}>
          {/* نام و نام خانوادگی */}
          <div className="twoCol">
            <div className="form-group">
              <label>
                نام و نام خانوادگی <span className="required">*</span>
              </label>
              <input
                type="text"
                name="fullName"
                value={CurrentUser?.name}
                // onChange={handleChange}
                readOnly
                placeholder="نام و نام خانوادگی خود را وارد کنید"
              />
              {errors.fullName && (
                <span className="error">{errors.fullName}</span>
              )}
            </div>

            {/* کد ملی */}
            <div className="form-group">
              <label>
                کد ملی <span className="required">*</span>
              </label>
              <input
                type="text"
                name="n_code"
                value={CurrentUser?.temp?.username}
                // onChange={handleChange}
                readOnly
                // placeholder="کد ملی ۱۰ رقمی"
                maxLength={10}
              />
              {errors.nationalCode && (
                <span className="error">{errors.nationalCode}</span>
              )}
            </div>
          </div>

          {/* جنسیت */}
          <div className="form-group">
            <label>
              جنسیت <span className="required">*</span>
            </label>
            <div className="radio-group">
              <label className="radio-label">
                <input
                  type="radio"
                  name="gender"
                  value="male"
                  checked={CurrentUser?.gender === "male"}
                  // onChange={handleChange}
                  readOnly
                />
                پسر
              </label>
              <label className="radio-label">
                <input
                  type="radio"
                  name="gender"
                  value="female"
                  checked={CurrentUser?.gender === "female"}
                  // onChange={}
                  readOnly
                />
                دختر
              </label>
            </div>
            {errors.gender && <span className="error">{errors.gender}</span>}
          </div>

          {/* شماره تماس */}
          <div className="form-group">
            <label>
              شماره تماس <span className="required">*</span>
            </label>
            <input
              type="tel"
              name="phone"
              value={CurrentUser?.temp?.phone}
              // onChange={handleChange}
              readOnly
              // placeholder="۰۹۱۲۳۴۵۶۷۸۹"
              maxLength={11}
            />
            {errors.phone && <span className="error">{errors.phone}</span>}
          </div>

          {/* استان */}
          <div className="twoCol">
            <div className="form-group">
              <label>
                استان <span className="required">*</span>
              </label>
              <input
                type="tel"
                name="phone"
                value={CurrentUser?.temp?.prv}
                // onChange={handleChange}
                readOnly
                // placeholder="۰۹۱۲۳۴۵۶۷۸۹"
              />
              {/* <select
            name="province"
            value={formData.province}
            onChange={handleChange}
          >
            <option value="">انتخاب استان...</option>
            {provinces.map(province => (
              <option key={province} value={province}>{province}</option>
            ))}
          </select> */}
              {errors.province && (
                <span className="error">{errors.province}</span>
              )}
            </div>

            {/* شهرستان */}
            <div className="form-group">
              <label>
                شهرستان <span className="required">*</span>
              </label>
              <input
                type="tel"
                name="phone"
                value={CurrentUser?.temp?.county}
                // onChange={handleChange}
                readOnly
                // placeholder="۰۹۱۲۳۴۵۶۷۸۹"
              />
              {errors.city && <span className="error">{errors.city}</span>}
            </div>
          </div>
          {/* مقطع تحصیلی */}
          <div className="form-group">
            <label>
              مقطع تحصیلی <span className="required">*</span>
            </label>
            <input
              type="tel"
              name="phone"
              defaultValue={formData.grade}
              // onChange={handleChange}
              readOnly
              // placeholder="۰۹۱۲۳۴۵۶۷۸۹"
            />
            {/* <select
            name="educationLevel"
            value={formData.educationLevel}
            onChange={handleChange}
          >
            <option value="">انتخاب مقطع...</option>
            {educationLevels.map(level => (
              <option key={level} value={level}>{level}</option>
            ))}
          </select> */}
            {errors.educationLevel && (
              <span className="error">{errors.educationLevel}</span>
            )}
          </div>

          {/* نام مدرسه */}
          <div className="form-group">
            <label>
              نام مدرسه <span className="required">*</span>
            </label>
            <input
              type="text"
              name="schoolName"
              value={formData.schoolName}
              onChange={handleChange}
              placeholder="نام مدرسه"
            />
            {errors.schoolName && (
              <span className="error">{errors.schoolName}</span>
            )}
          </div>

          {/* آدرس */}
          {/* <div className="form-group">
            <label>آدرس منزل</label>
            <textarea
              name="address"
              value={formData.address}
              onChange={handleChange}
              placeholder="آدرس کامل منزل"
              rows={3}
            />
            <span className="error">اختیاری </span>
          </div> */}

          {/* کد پستی */}
          {/* <div className="form-group">
            <label>کد پستی خانه</label>
            <input
              type="text"
              name="postalCode"
              value={formData.postalCode}
              onChange={handleChange}
              placeholder="کد پستی ۱۰ رقمی"
              maxLength={10}
            />
            <span className="error">
              اختیاری - تنها عدد و به انگلیسی وارد نمایید
            </span>
          </div> */}

          {/* مسئول انجمن اسلامی */}
          {/* <div className="form-group"> */}

          {/* قصد برگزاری نمایشگاه */}
          <div className="form-group">
            <label>آیا قصد شرکت دارید؟</label>
            <div className="radio-group">
              <label className="radio-label">
                <input
                  type="radio"
                  name="wantToHold"
                  value="بله"
                  checked={formData.wantToHold === "بله"}
                  onChange={handleChange}
                />
                بله
              </label>
              <label className="radio-label">
                <input
                  type="radio"
                  name="wantToHold"
                  value="خیر"
                  checked={formData.wantToHold === "خیر"}
                  onChange={handleChange}
                />
                خیر
              </label>
              {/* <label className="radio-label">
                <input
                  type="radio"
                  name="wantToHold"
                  value="نامشخص"
                  checked={formData.wantToHold === "نامشخص"}
                  onChange={handleChange}
                />
                هنوز مشخص نیست
              </label> */}
            </div>
          </div>

          {/* سابقه برگزاری */}
          {/* <div className="form-group">
            <label>آیا در سال‌های گذشته مدرسه انقلاب برگزار کرده‌اید؟</label>
            <div className="radio-group">
              <label className="radio-label">
                <input
                  type="radio"
                  name="heldBefore"
                  value="بله"
                  checked={formData.heldBefore === "بله"}
                  onChange={handleChange}
                />
                بله
              </label>
              <label className="radio-label">
                <input
                  type="radio"
                  name="heldBefore"
                  value="خیر"
                  checked={formData.heldBefore === "خیر"}
                  onChange={handleChange}
                />
                خیر
              </label>
            </div>
          </div> */}

          {/* روش تحویل */}
          {/* <div className="form-group">
            <label>نحوه دریافت اقلام مدرسه انقلاب</label>
            <select
              name="deliveryMethod"
              value={formData.deliveryMethod}
              onChange={handleChange}
            >
              <option value="">انتخاب روش تحویل...</option>
              {deliveryMethods.map((method) => (
                <option key={method} value={method}>
                  {method}
                </option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label>آدرس محل تحویل مرسوله*</label>
            <textarea
              name="deliverAddress"
              value={formData.deliverAddress}
              onChange={handleChange}
              placeholder="آدرس کامل منزل"
              rows={3}
            />
          </div> */}

          {/* کد پستی */}
          {/* <div className="form-group">
            <label>کد پستی محل تحویل مرسوله*</label>
            <input
              type="text"
              name="deliverPostalCode"
              value={formData.deliverPostalCode}
              onChange={handleChange}
              placeholder="کد پستی ۱۰ رقمی"
              maxLength={10}
            />
            <span className="error">تنها عدد و به انگلیسی وارد نمایید</span>
          </div> */}

          {/* دکمه ثبت */}
          <button type="submit" className="submit-btn" disabled={disBtn}>
            ثبت اطلاعات
          </button>
        </form>

        {/* <div className="dlBox">
          <a
            target="_blank"
            href="https://madreseenghelab.com/%D8%B4%DB%8C%D9%88%D9%87-%D9%86%D8%A7%D9%85%D9%87/"
          >
            دانلود شیوه نامه دانش آموزی مدرسه انقلاب
          </a>
        </div> */}
      </div>

      <Hidden smDown>
        <DeskFooter />
      </Hidden>
      <Hidden mdUp>
        <MobileFooter />
      </Hidden>
    </>
  );
};

export default TalayeDaranRegister;
